import { InteractionState } from "@edgetier/watchtower-types";

/**
 * Convert the interaction state into a class name.
 * @param interactionState Interaction state.
 * @returns                Class name.
 */
export const createClassName = (interactionState: InteractionState) => {
    const cleanedName = interactionState
        .replace("_", "-")
        .replace(/([a-z])([A-Z])/g, "$1-$2")
        .toLowerCase();

    return `interactions-table-state-column--is-${cleanedName}`;
};
